import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Link } from 'react-router-dom';
import logo from './logo.png';
import { usePageTitle } from 'routes/Util/Util.hooks';
import lastDayOfMonth from 'date-fns/lastDayOfMonth';
import format from 'date-fns/format';
import ko from 'date-fns/locale/ko';

export const EventPage = () => {
  usePageTitle('이벤트');
  const lastDay = lastDayOfMonth(new Date());

  return (
    <Container>
      <Row className="mb-5">
        <Col className="text-center">
          <img src={logo} alt="Starbucks" width="180" height="180" />
        </Col>
      </Row>
      <Row>
        <Col>
          <h2 className="text-center">
            본인만의 투자 아이디어 남기고, 스타벅스 Gift Card 받아가세요.
          </h2>
        </Col>
      </Row>
      <Row>
        <Col>
          <dl>
            <dt>기간</dt>
            <dd>~ {format(lastDay, 'PPPp', { locale: ko })}</dd>
            <dt>상품</dt>
            <dd>스타벅스 1만원 Gift Card 3명</dd>
            <dt>참여방법</dt>
            <dd>
              <Link to="/ideas">아이디어 페이지</Link>로 이동 후, 본인만의 투자
              아이디어를 남겨주세요.
            </dd>
            <dt>선정방식</dt>
            <dd>
              <ul>
                <li>좋아요를 가장 많이 받은 글을 작성한 유저 3명</li>
                <li>중복 컨텐츠 및 무의미한 컨텐츠 제외</li>
              </ul>
            </dd>
            <dt>상품전달방식</dt>
            <dd>가입하신 이메일로 Gift Card를 전송해 드립니다.</dd>
          </dl>
        </Col>
      </Row>
    </Container>
  );
};
